module.exports = __webpack_public_path__ + "img/11-2.f0863806.png";